import { render } from "./RecapitulatifVigeo.vue?vue&type=template&id=52c2a815"
import script from "./RecapitulatifVigeo.vue?vue&type=script&lang=js"
export * from "./RecapitulatifVigeo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__